var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83594 4.26855V0.268555L3.83594 5.26855L8.83594 10.2686V6.26855C12.1459 6.26855 14.8359 8.95856 14.8359 12.2686C14.8359 15.5786 12.1459 18.2686 8.83594 18.2686C5.52594 18.2686 2.83594 15.5786 2.83594 12.2686H0.835938C0.835938 16.6886 4.41594 20.2686 8.83594 20.2686C13.2559 20.2686 16.8359 16.6886 16.8359 12.2686C16.8359 7.84855 13.2559 4.26855 8.83594 4.26855Z",
    fill: "#006BBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.d241fbb33b3ca2490cec825c4a532b3b.svg";
export { ForwardRef as ReactComponent };